export const AllProgramsTableHeading = [
  {
    text: 'S.No.',
    dataField: 'sNo',
  },
  {
    text: 'Weekdays',
    dataField: 'weekName',
  }
]